import React from 'react';

import { gql } from '@apollo/client';

import { ActivityLogTaskAgentUndelegated_ActivityLogFragment } from 'src/generated/mloop-graphql';

import { FCWithFragments } from 'src/components/types';

import ActivityLogBase from 'src/entities/ActivityLog/Helpers/ActivityLogBase';
import { useAiAgentLabel } from 'src/entities/ActivityLog/Helpers/useAiAgentLabel';

import useIsAiTaskEnabled from 'src/hooks/useIsAiTaskEnabled';

interface Fragments {
  activityLog: ActivityLogTaskAgentUndelegated_ActivityLogFragment;
}

const ActivityLogTaskAgentUndelegated: FCWithFragments<Fragments> = ({ activityLog }) => {
  const aiTaskEnabled = useIsAiTaskEnabled();
  const aiAgentLabel = useAiAgentLabel();
  if (!aiTaskEnabled) {
    return null;
  }

  return <ActivityLogBase activityLog={activityLog} actionLabel={`undelegated from ${aiAgentLabel}`} />;
};

ActivityLogTaskAgentUndelegated.fragments = {
  activityLog: gql`
    ${ActivityLogBase.fragments.activityLog}
    fragment ActivityLogTaskAgentUndelegated_activityLog on ActivityLog {
      id
      ...ActivityLogBase_activityLog
    }
  `,
};

export default ActivityLogTaskAgentUndelegated;
